import NanoModal from "./modal";
import iFrameResize from "iframe-resizer";

export default function initOfferModal() {
  document.addEventListener("click", (e) => {
    if (!e.target.classList.contains("open-offer-modal")) {
      return;
    }

    const modalTrigger = e.target;
    const repeaterRow = modalTrigger.dataset.row;
    const repeaterSubRow = modalTrigger.dataset.subRow;
    const offerID = modalTrigger.dataset.offerId;
    const offerBaseUrl = modalTrigger.dataset.url;

    // Create the iframe
    const iframe = document.createElement("iframe");
    iframe.src = `${offerBaseUrl}?offer-modal&repeater-row=${repeaterRow}&repeater-sub-row=${repeaterSubRow}&offer-id=${offerID}`;
    iframe.width = "100%";
    iframe.setAttribute("frameborder", "0");

    // Create the modal
    const modal = new NanoModal("#offer-modal", {
      onShow: () => {
        modalTrigger.setAttribute("aria-expanded", "true");
        modalTrigger.classList.add("modal-trigger-open");

        const modalContent = document.querySelector(
          "#offer-modal .offer-modal-content"
        );

        // Append the iframe to the modal content
        modalContent.appendChild(iframe);

        // Initialize iframe resizer
        iFrameResize.iframeResizer(
          {
            heightCalculationMethod: "taggedElement",
          },
          iframe
        );

        // Add 'modal-loading' class to body to hide the modal and show the spinner
        document.body.classList.add("modal-loading");
      },
      onClose: () => {
        modalTrigger.setAttribute("aria-expanded", "false");
        modalTrigger.classList.remove("modal-trigger-open");

        // Remove iframe when modal is closed
        const modalContent = document.querySelector(
          "#offer-modal .offer-modal-content"
        );
        modalContent.innerHTML = "";

        // Remove body classes
        document.body.classList.remove("modal-loading");
        document.body.classList.remove("modal-loaded");
      },
      closeOnEscape: true,
      closeOnOutsideClick: false,
      disableScrollShift: true,
      disableScroll: true,
      debug: false,
    });

    // Show the modal immediately (it will be hidden via CSS)
    modal.showModal();

    // When the iframe loads, remove 'modal-loading' and add 'modal-loaded' to show the modal
    iframe.onload = function () {
      // Remove 'modal-loading' class to show the modal
      document.body.classList.remove("modal-loading");
      document.body.classList.add("modal-loaded");
    };
  });
}
